import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '@client/components/ui/input';
import { Button } from '@client/components/ui/button';
import { Alert, AlertDescription } from '@client/components/ui/alert';
import { selectAdvisorAdminPortalState } from '@/model/selectors';
import { postAdvisorForAdminSearchRequest } from '@/model/advisorAdminPortalModel';

interface AdminSearchBarProps {
  onAdvisorSelected: (advisor: Advisor) => void;
}

export function AdminSearchBar({ onAdvisorSelected }: AdminSearchBarProps) {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState('');
  const { advisorFetchStatus, advisorFetchError, selectedAdvisor } = useSelector(selectAdvisorAdminPortalState);

  const handleSearch = () => {
    if (!searchQuery.trim()) return;

    const query = searchQuery.trim();
    const isEmail = query.includes('@');

    dispatch(
      postAdvisorForAdminSearchRequest(isEmail ? { advisorEmail: query } : { advisorId: query }),
    );
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  // Call callback when advisor is found
  React.useEffect(() => {
    if (selectedAdvisor) {
      onAdvisorSelected(selectedAdvisor);
    }
  }, [selectedAdvisor]);

  return (
    <div className="flex-1 space-y-2">
      <div className="flex gap-2">
        <div className="flex-1 max-w-md">
          <Input
            type="text"
            placeholder="Enter advisor ID or email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={advisorFetchStatus === 'loading'}
            className="h-9"
          />
        </div>
        <Button
          onClick={handleSearch}
          disabled={!searchQuery.trim() || advisorFetchStatus === 'loading'}
          size="sm"
          className="h-9"
        >
          Search
        </Button>
      </div>

      {advisorFetchError && (
        <Alert variant="destructive" className="py-2">
          <AlertDescription className="text-sm">
            {advisorFetchError}
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}

